<template>
  <div class="mypage-point-year-section">
    <p class="mypage-point-year-section__title">{{ monthlyData.month }}</p>
    <ul class="mypage-point-year-section__list">
      <li
        v-for="item in monthlyData.pointList"
        :key="item.id"
        class="mypage-point-year-section__item"
      >
        <mypage-point-item-parts :item="item" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MypagePointItemParts from '@/components/MypagePointHistoryPage/MypagePointHistoryPane/parts/MypagePointItemParts.vue'

export default defineComponent({
  name: 'MypagePointMonthlySection',
  components: { MypagePointItemParts },
  props: {
    monthlyData: {
      type: Object,
    },
  },
})
</script>

<style scoped lang="scss">
.mypage-point-year-section {
  &__title {
    font-family: $fontSignup;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.42;
    letter-spacing: 0.02em;
  }

  &__list {
    margin-top: 12px;
    border-top: 1px solid $black10;
  }

  &__item {
    border-bottom: 1px solid $black10;
  }
}
</style>
